module.exports = __webpack_public_path__ + "static/media/icon-end-date.11baec82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DatePickerInput/icon-end-date.svg
// module id = 1197
// module chunks = 0